import { useState, useEffect, useCallback } from 'react';
import { useAuth } from './useAuth';
import { hacerSolicitud } from '../helpers/apiClient';
import { urlApi } from '../helpers/functionHelpers';

const useObtenerCitaPorFecha = (almacenId, fecha) => {
  const { renovarToken, cerrarSesion } = useAuth();
  const [citas, setCitas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const obtenerCitas = useCallback(async () => {
    if (!almacenId || !fecha) return;

    setLoading(true);
    setError(null);

    try {

      const data = await hacerSolicitud(
        `${urlApi}/api/citas?almacenId=${almacenId}&fecha=${fecha}`,
        { method: 'GET' },
        renovarToken,
        cerrarSesion
      );
      setCitas(data);

    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [almacenId, fecha, renovarToken, cerrarSesion]);

  useEffect(() => {
    obtenerCitas();
  }, [obtenerCitas]);

  return { citas, loading, error, actualizarCitas: obtenerCitas };
};

export default useObtenerCitaPorFecha;

